/**
 * Tool Result Component
 *
 * Displays the success, error, or empty state message for a tool.
 */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ToolResult({ message, state }) {
    // Prefix based on state
    const prefix = state === 'error' ? 'Error: ' : state === 'empty' ? '' : '';
    return /*#__PURE__*/ _jsxs("div", {
        className: "text-xs",
        children: [
            prefix && /*#__PURE__*/ _jsx("span", {
                className: "font-medium",
                children: prefix
            }),
            /*#__PURE__*/ _jsx("span", {
                children: message
            })
        ]
    });
}
